import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { TaskDetailsType, TaskKindType, TaskNotifyType } from '@/types/dashboardTypes';

export type CreateTaskPayloadType = {
  kind: TaskKindType;
  assigned_to_id: string;
  notify: TaskNotifyType;
  title?: string;
  note?: string;
  due_date?: string | null; // YYYY-MM-DD
  source_event_id?: string | null;
  linked_label?: string;
};

export const createTaskApi = (
  payload: CreateTaskPayloadType,
  options: RequestOptions
): Promise<ApiResponseType<TaskDetailsType>> => {
  return authApiService.POST('/dashboard/tasks/', payload, null, options);
};
